import { enqueueSnackbar } from 'notistack';

/*
  Characters that are operators in SQL Server's full-text query language.

  A name search backed by a full-text index (the Customers page's tabs) rewrites its input
  into quoted CONTAINS() prefix terms. Left in place these are not searched for -
  SQL Server reports "the full-text search condition contained noise word(s)" and,
  because the terms are AND-joined, the whole search then matches nothing: on dev2,
  "R & R" found no "R & R Livestock" and "land & cattle" found no "Jorgensen Land &
  Cattle".

  They are refused as the user types, so the box never accepts a character the
  search cannot use. The server strips the same set again in
  EntityTouchpointListRequestBo.BuildFullTextSearchTerm - the API is reachable
  without going through this input - so the two lists are kept in step.
*/
const FULL_TEXT_OPERATORS = /["*()&]/g;

/*
  Strips those characters AND tells the user which one was refused - a key that
  silently does nothing reads as a broken keyboard. Pass as a CasTextField
  `sanitize`; it runs per keystroke, so the snackbar leans on SnackbarProvider's
  preventDuplicate + 3s autoHide (see components/snackbar/snackbar-provider) rather
  than tracking what it has already said.
*/
export default function sanitizeSearchText(value: string) {
  const refused = Array.from(new Set(value.match(FULL_TEXT_OPERATORS) ?? []));

  if (refused.length)
    enqueueSnackbar(`Special characters (${refused.join(' ')}) not allowed`, {
      variant: 'warning',
    });

  return value.replace(FULL_TEXT_OPERATORS, '');
}
